import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import debounce from 'lodash/debounce'
import throttle from 'lodash/throttle'
import findIndex from 'lodash/findIndex'  
import find from 'lodash/find' 
import DocumentTitle from 'react-document-title'
import { hideMenu } from 'react-contextmenu/modules/actions'
import {loadInitialData} from '../../actions/initialData'
import {fetchASet,updateSetContent,updateSetMeta,newSet,deleteSet } from '../../actions/library/sets'
import {updateSetLock ,deleteLockForSet,synchronousDeleteLockForSet} from '../../actions/locks'
import {showNotification,hideNotification} from '../../actions/notifications'
import {uploadNewImageToCloudinary} from '../../actions/cloudinary'
import {copyQuestion} from '../../utils/copyPaste'
import {showDuplicateAndEditModal,showImportQuestionsModal, showRepoSelectionModal,finishImageUpload,showImageSearchModal,showGifSearchModal,hideModal,showConfirmModal} from '../../actions/modals'
import {isSurvey} from '../../utils/isSurvey'
import {updateQuestionWithFormValues} from '../../utils/editors/updateQuestionWithFormValues'
import {setToSurvey} from '../../utils/editors/setToSurvey'
import {setToGraded} from '../../utils/editors/setToGraded'
import {setToTrueFalse} from '../../utils/editors/setToTrueFalse'
import {makeACopySet} from '../../utils/editors/makeACopy'
import {newQuestionInSet} from '../../utils/editors/newQuestionInSet'
import {newSetTemplate} from '../../utils/editors/setTemplates'
import SetEditor from '../../components/editors/SetEditor'
import update from 'immutability-helper'
import {playItem} from '../../utils/playItem'
import {shuffleChoices} from '../../utils/editors/shuffleChoices'
import {saveImageSearchModalImage} from '../../actions/modals'
import {repoPusherSetup} from '../../utils/pusher/repoPusherSetup'
 
 	
const DEBOUNCE_TIME=1000
const LOCK_THROTTLE_TIME=1000*10
const CONTEXT_MENU_CLOSE_DELAY = 150
//If the question has no image then question.body=emptyBodyText (but in form question.body='' so it is a placeholder in text area)
//if question has an image then question.body='' and emptyBodyText is a real placeholder
const emptyBodyText='Click here to edit question'
const shufflingTime=750
const shuffleDelay=375

const MAX_FILE_SIZE=20000000

 
const xLayoutVersion=parseInt(process.env.REACT_APP_XLAYOUT_VERSION,10)


class SetEditorContainer extends Component {
  
	constructor(props){
		super(props)
		this.handleContextMenuClick=this.handleContextMenuClick.bind(this)
		this.createNewSet=this.createNewSet.bind(this)
		this.newQuestionInSet=this.newQuestionInSet.bind(this)
		this.changeActiveQuestion=this.changeActiveQuestion.bind(this)
		this.handleQuestionListKeyDown=this.handleQuestionListKeyDown.bind(this)
		this.handleQuestionCardKeyDown=this.handleQuestionCardKeyDown.bind(this)
		this.moveSlideDown=this.moveSlideDown.bind(this)
		this.moveSlideUp=this.moveSlideUp.bind(this)
		this.moveSlideToBottom=this.moveSlideToBottom.bind(this)
		this.moveSlideToTop=this.moveSlideToTop.bind(this)
		this.cutQuestion=this.cutQuestion.bind(this)
		this.pasteQuestion=this.pasteQuestion.bind(this)
		this.reorderQuestionsInSet=this.reorderQuestionsInSet.bind(this)
		this.updateSetTitle=this.updateSetTitle.bind(this)
		this.showArchiveSetModal=this.showArchiveSetModal.bind(this)
		this.archiveSet=this.archiveSet.bind(this)
		this.handleEditFormOnChange=this.handleEditFormOnChange.bind(this)    
		this.handleChangeTemplate=this.handleChangeTemplate.bind(this)  
		this.uploadImage=this.uploadImage.bind(this)    
		this.handleSetToSurvey=this.handleSetToSurvey.bind(this)   
		this.handleSetToGraded=this.handleSetToGraded.bind(this)      
		this.handleMakeACopy=this.handleMakeACopy.bind(this)
		this.saveChanges=this.saveChanges.bind(this)
		this.updateSet=this.updateSet.bind(this)
		this.clearTempImage=this.clearTempImage.bind(this)
		this.focusEditTitleField=this.focusEditTitleField.bind(this)
		this.deleteQuestionInSet=this.deleteQuestionInSet.bind(this)
		this.duplicateQuestion=this.duplicateQuestion.bind(this)
		this.updateFontSizes=this.updateFontSizes.bind(this)
		this.handleBodyOnChange=this.handleBodyOnChange.bind(this)
		this.handleChoiceOnChange=this.handleChoiceOnChange.bind(this)
		this.handlePlaySet=this.handlePlaySet.bind(this)
		this.handleSetToTrueFalse=this.handleSetToTrueFalse.bind(this)
		this.handleAddChoice=this.handleAddChoice.bind(this)
		this.handleCopyQuestion=this.handleCopyQuestion.bind(this)
		this.handleShuffleChoices=this.handleShuffleChoices.bind(this)
		this.handleLockedOut=this.handleLockedOut.bind(this)
		this.delayedMenuClose = debounce(this.delayedMenuClose,CONTEXT_MENU_CLOSE_DELAY)

		this.handleFileUpload=this.handleFileUpload.bind(this)
		this.beforeUnload=this.beforeUnload.bind(this)
		this.lockItem=this.lockItem.bind(this)
		this.shouldDeleteLock=this.shouldDeleteLock.bind(this)

		this.showImageSearchModal=this.showImageSearchModal.bind(this)
		
		this.promises=[]


		this.saveChanges = debounce(this.saveChanges,DEBOUNCE_TIME,{'leading': false })


		this.lockItem = throttle(this.lockItem,LOCK_THROTTLE_TIME,{'edge': 'both' })


		let currentSet=null
		let activeQuestion
		let hasImage
		let activeQuestionTemplate='standard'
		let activeQuestionIsSurvey=false
		let parentFolder=null//We use the parentFolder for creating sets within folders
		let repo=null
		if(typeof window.parentFolder === 'string'){//Prevent invalid folder value
			parentFolder=window.parentFolder
		}
		if(typeof window.repo === 'string'){//Prevent invalid folder value
			repo=window.repo
		}

		
		if(props.match.params.id === 'newSet'){
			currentSet=newSetTemplate()
			currentSet.folder=parentFolder
			currentSet.repo=repo
			activeQuestion=currentSet.questions[0]
			hasImage=false
  
		}
		else if(props.currentSet) {
			hasImage=true
			if(props.currentSet.questions[0].image ===''){
				hasImage=false
			}

			currentSet=props.currentSet
			activeQuestion=props.currentSet.questions[0]
			activeQuestionTemplate=props.currentSet.questions[0].template
			activeQuestionIsSurvey=isSurvey(activeQuestion)
		}


		this.state={
			set:currentSet,
			userLockedSet:false,
			activeQuestion:activeQuestion,
			activeQuestionIndex:0,
			activeQuestionTemplate:activeQuestionTemplate,
			isSurvey:activeQuestionIsSurvey,
			uploadedFileCloudinaryUrl: '',
			lastSaved:null,
			isSaving:false,
			unableToSave:false,
			uploadingToCloudinary:false,
			tempImage:null,			
			hasImage:hasImage,
			imageSearchTerm:null,
			imageSearchResults:null,
			isShuffling:false
		}
	} 

	componentDidMount(){
		window.addEventListener('beforeunload', this.beforeUnload)
		let loadState='Edit'
		if(this.props.match.params.id === 'newSet'){
			loadState='New'
		}
		if(window.analytics){
			window.analytics.page('Item Editor',{itemType:'Set',loadState:`${loadState}`})

		}
	}

	componentWillUnmount() {
		window.removeEventListener('beforeunload', this.beforeUnload)
		this.props.hideNotification()
		this.props.loadInitialData(this.props.currentUser.id)
		
		const shouldDeleteLock = this.shouldDeleteLock()
		if(shouldDeleteLock){
			this.props.deleteLockForSet(this.props.match.params.id)
			this.lockItem.cancel()
		}
	}	




	 beforeUnload() { 
	 	const shouldDeleteLock = this.shouldDeleteLock()
	 	if(shouldDeleteLock){
	 		this.props.synchronousDeleteLockForSet(this.props.match.params.id)
		 }
	 }	

	 shouldDeleteLock(){
	 	if(this.state.userLockedSet){

	 			return true
	 	}else{
	 		if(this.props.lock && this.props.currentSet && this.props.currentSet.repo && !this.props.itemIsLockedByAnotherUser ){
	 			return true
	 		}
	 		else{
	 			return false
	 		}
	 		
	 	}

	 }




	UNSAFE_componentWillReceiveProps(nextProps) {
		if(!this.props.parentRepo && nextProps.parentRepo && nextProps.parentRepo.shared){
			repoPusherSetup(nextProps.parentRepo.id)
		}
		if(this.state.set === null && nextProps.currentSet) {
			let hasImage=true
			if(nextProps.currentSet.questions[0].image ===''){
				hasImage=false
			}

			this.setState({
				set:nextProps.currentSet,
				activeQuestion:nextProps.currentSet.questions[0], 
				activeQuestionIndex:0,
				activeQuestionTemplate:nextProps.currentSet.questions[0].template,
				isSurvey:isSurvey(nextProps.currentSet.questions[0]),
				hasImage:hasImage
			})
		}

		if(!this.props.itemIsLockedByAnotherUser && nextProps.itemIsLockedByAnotherUser){
			this.handleLockedOut()
		}

		if(this.props.currentModal==='IMPORT_QUESTIONS_MODAL' && nextProps.currentModal!=='IMPORT_QUESTIONS_MODAL'){
			if(nextProps.currentSet){
				this.setState({set:nextProps.currentSet,activeQuestion:nextProps.currentSet.questions[this.state.activeQuestionIndex] }) //for import questions
			}
		}


		if(this.props.itemIsLockedByAnotherUser && this.props.currentSet !== nextProps.currentSet){
			const {activeQuestion} = this.state
			const newActiveQuestionIndex =findIndex(nextProps.currentSet.questions, function (setQuestion) {
				return setQuestion.questionId === activeQuestion.questionId
			})
			let hasImage=true
			if(nextProps.currentSet.questions[newActiveQuestionIndex].image ===''){
				hasImage=false
			}

			this.setState({
				set:nextProps.currentSet,
				activeQuestionIndex:newActiveQuestionIndex,
				activeQuestion:nextProps.currentSet.questions[newActiveQuestionIndex], 
				activeQuestionTemplate:nextProps.currentSet.questions[newActiveQuestionIndex].template,
				isSurvey:isSurvey(nextProps.currentSet.questions[newActiveQuestionIndex]),
				hasImage:hasImage
			})

		}

		//upload image selected from modal
		if(this.props.uploadingImage !== nextProps.uploadingImage && nextProps.uploadingImage) {
			this.setState({
				tempImage: nextProps.thumbnail,
				hasImage:true,
				imageSearchTerm:nextProps.imageSearchTerm,
				imageSearchResults:nextProps.imageSearchResults
			})
			this.uploadImage(nextProps.uploadingImage,nextProps.thumbnail)
		}


		if(this.props.currentUserPermission && !nextProps.currentUserPermission){
			this.props.history.push('/library') //if permission is deleted for current user for repo that item they are editing is in then redirect to library
		}



	}

	handleLockedOut(){
		this.props.hideModal()
		//blur inputs when locked out
		var tmp = document.createElement('input')
 		document.body.appendChild(tmp)
		tmp.focus()
 		document.body.removeChild(tmp)
	}



	lockItem(){
		if(this.props.currentSet && this.props.currentSet.repo){
			this.setState({userLockedSet:true})
			this.props.updateSetLock(this.props.match.params.id)
		}
	}



 	handleFileUpload(e){
		const fileList = e.target.files
		const file = fileList[0]
		if(file && (file.size > MAX_FILE_SIZE)){
			this.props.hideModal()
			this.props.showNotification('Max image upload is 20mb','Cannot upload image','destroy')

		}else{
			const reader = new FileReader()
			reader.readAsDataURL(file)
			reader.onload = (event) => {
				this.props.saveImageSearchModalImage(event.target.result,event.target.result)
			}
		}
	}

 
	handleMakeACopy(){
		return this.props.makeACopySet(this.props.currentSet).then((response) => {
			window.open(`/seteditor/${response.id}`, '_blank')
		})
	}

	showArchiveSetModal(){
		this.props.showConfirmModal(this.props.currentSet.name,this.archiveSet,'trash')
	}


	archiveSet(){
		const nowDate = new Date()
	  	const requestData = {
	        ...this.props.currentSet,
	        clientModified: nowDate,
	        archived: true
	    }
	 return this.props.updateSetMeta(requestData,this.props.currentSet.id).then(() => {
	  this.props.hideModal()
	  this.props.history.push('/library')	
	 })
	}


 
	uploadImage(img,thumbnail) {
		this.lockItem()
		this.setState({
			uploadingToCloudinary: true,
		})
		this.props.hideModal()
		const questionId=this.state.activeQuestion.questionId
		this.props.uploadNewImageToCloudinary(img,thumbnail).then((response) => {
			this.handleEditFormOnChange(response.public_id, 'image',null,questionId)
			this.props.finishImageUpload()

		})
		 .catch((error) => {
		 	this.clearTempImage()
		 })
	}


	clearTempImage(){
		this.setState({tempImage:null})
	}


	//A new set is created on the first edit made in setEditor.  
	//if the first edit is to add a question to the set, it will be created with 2 questions
	createNewSet(set) {
		this.setState({isSaving:true,unableToSave:false})
		const nowDate = new Date()
		const requestData = {
			...set,
			'clientModified': nowDate,
			'userCreated':nowDate,
			'lastEditedAt':nowDate,				
		}
		return this.props.newSet(requestData).then((response) => {
			this.props.history.push(`./${response.id}`)
			this.setState({isSaving:false, lastSaved:response.clientModified,unableToSave:false,set:{...this.state.set,id:response.id}})
			if(response.repo){
				this.props.updateSetLock(this.props.match.params.id)
				this.setState({userLockedSet:true})
			}
			
			
			return null
		})
			.catch(error => {
				this.setState({isSaving:false, unableToSave:true})
				this.promises=[]
			})
	}


	//editedQuestion is only used for image uploads when have to wait for cloudinary (active question may change)
	//TODO seperate image uploads from other edits
	handleEditFormOnChange(value,field,index,questionId){
		this.lockItem()
		let {set,activeQuestionIndex,activeQuestion}=this.state

		//Temp fix
		let questionIndex=activeQuestionIndex
		let question=activeQuestion
		if(questionId){

		 questionIndex = findIndex(set.questions, function (setQuestion) {
				return setQuestion.questionId === questionId
			})
		 	question=set.questions[questionIndex]
		}

		 if(field==='removeChoice' && question.choices[index].correct){
			 		this.setState({isSurvey:true})
			 }
		if(field==='radio'){
			if(value==='false'){
				this.setState({isSurvey:false})			//if setting a choice to correct the question is no longer a survey
			}
			else if(value==='true'){
				this.setState({isSurvey:true})
				//if setting a corect choice to incorrect it becomes a survey
				//const notificationMessage=`Changed ${activeQuestion.body} to survey`
				//this.props.showNotification(notificationMessage,'green')
			}		
		}

		if(field ==='image'){
			this.setState({uploadingToCloudinary:false})
			if(value===''){
				this.setState({hasImage:false,tempImage:null})
			}else{
				this.setState({hasImage:true})
			}
		}
		

		const updatedQuestion= updateQuestionWithFormValues(value,field,index,question||activeQuestion)
		
		const updatedSet= update(this.state.set, 
			{questions:
				{[questionIndex]:{$set: updatedQuestion}
				}})

		this.setState({set:updatedSet})
		if(questionIndex===this.state.activeQuestionIndex){
			this.setState({activeQuestion:updatedQuestion,activeQuestionTemplate:updatedQuestion.template}) //only update active question if user is still on that question
		}
		this.saveChanges()
	}

	handleBodyOnChange(value){
		this.lockItem()
		const nowDate=new Date()
		let body=value
		if(value==='' && !this.state.hasImage){
			body=emptyBodyText
		}
		const updatedSet= update(this.state.set, 
			{questions:
				{[this.state.activeQuestionIndex]:{body: {$set: body}}}
				,clientModified: {$set: nowDate}
			})
 		this.setState({set:updatedSet,activeQuestion:updatedSet.questions[this.state.activeQuestionIndex]})
		this.saveChanges()
	}

	handleChoiceOnChange(value,index){
		this.lockItem()
		const nowDate=new Date()
		const updatedSet= update(this.state.set, 
			{questions:
				{[this.state.activeQuestionIndex]:
					{choices: 
						{[index]:{
							body:{$set: value}
						}}}},
			clientModified: {$set: nowDate}
			})
		this.setState({set:updatedSet,activeQuestion:updatedSet.questions[this.state.activeQuestionIndex]})
		this.saveChanges()
	}


	handleShuffleChoices(){
		this.lockItem()
		if(!this.state.isShuffling){
			this.setState({isShuffling:true})
			this.setState({isShufflingStart:true})
			setTimeout(() => {
	            this.setState({
	            isShuffling:false
	          })
	        }, shufflingTime)

			setTimeout(() => {
	            this.setState({
	            isShufflingStart:false
	          })
	        }, shufflingTime/2)
			

			setTimeout(() => {
		    const oldChoices=this.state.activeQuestion.choices.slice()
				const newChoices=shuffleChoices(oldChoices)
				const nowDate=new Date()
				const updatedSet= update(this.state.set, 
					{questions:
							{[this.state.activeQuestionIndex]:
								{choices: 
									{$set: newChoices}				
								}},
					clientModified: {$set: nowDate}
					})
				this.setState({set:updatedSet,activeQuestion:updatedSet.questions[this.state.activeQuestionIndex]})
				this.saveChanges()      
	       }, shuffleDelay)
		}
	}



	updateSet(set){
		this.setState({isSaving:true,unableToSave:false})

		return this.props.updateSetContent(set,set.id).then((response)=>{
			if(response==='failed'){
				this.setState({unableToSave:true})
			}else{
				this.setState({isSaving:false, lastSaved:response.clientModified,unableToSave:false})
			}	
		})
	}


	updateFontSizes(field,value,bodyHeight){
		if(!this.props.itemIsLockedByAnotherUser){
			if(field==='body'){
			   this.setState(function(prevState){
			      return {set: {...prevState.set,questions:[
						...prevState.set.questions.slice(0,this.state.activeQuestionIndex),
						{...prevState.set.questions[this.state.activeQuestionIndex], xLayout:{...prevState.set.questions[this.state.activeQuestionIndex].xLayout,bodyH:bodyHeight,bodyFS:value,version:xLayoutVersion}},
						...prevState.set.questions.slice(this.state.activeQuestionIndex + 1)
			      	]
			      }
			   }}, () => {
	  			this.saveChanges()
	   		 })
			}
			
			else if(field==='choices'){
			   this.setState(function(prevState){
			      return {set: {...prevState.set,questions:[
						...prevState.set.questions.slice(0,this.state.activeQuestionIndex),
						{...prevState.set.questions[this.state.activeQuestionIndex], xLayout:{...prevState.set.questions[this.state.activeQuestionIndex].xLayout,choiceFS:value,version:xLayoutVersion}},
						...prevState.set.questions.slice(this.state.activeQuestionIndex + 1)
			      	]		 
			      }
			   }}, () => {
	  			this.saveChanges()
	   		 })
			}
		}
	
	}




	saveChanges(){
		let isViewOnly=false
		if(this.props.parentRepo && (this.props.parentRepo.role === 'viewer'|| this.props.parentRepo.role === 'consumer')){
  			isViewOnly = true
  		}
  		if(!isViewOnly && !this.props.itemIsLockedByAnotherUser){
			const {set}=this.state
			const nowDate=new Date()

			set.clientModified=nowDate
			if(!set.id){
				//only create the set once
				if(this.promises.length===0){
					this.promises.push(this.createNewSet(set))
				}
				//if you make additional changed after you have started creating the set then wait until it is created to update it 
				else{ Promise.all(this.promises).then(function () {
					this.updateSet(this.state.set)		
				}.bind(this))
				}
			}else{
				this.updateSet(set)		
			}
		}
	}


	handleSetToSurvey(){
		this.lockItem()
		let {set,activeQuestion,activeQuestionIndex}=this.state
		this.setState({isSurvey:true})
		activeQuestion=setToSurvey(activeQuestion)
		set.questions[activeQuestionIndex]=activeQuestion
		this.setState({set:set,activeQuestion:activeQuestion})
		this.saveChanges()
	}

	handleSetToGraded(){
		this.lockItem()
		let {set,activeQuestion,activeQuestionIndex}=this.state
		this.setState({isSurvey:false})
		activeQuestion=setToGraded(activeQuestion)
		set.questions[activeQuestionIndex]=activeQuestion
		this.setState({set:set,activeQuestion:activeQuestion})
		this.saveChanges()
	}

	handleSetToTrueFalse(){
		this.lockItem()
		let {set,activeQuestion,activeQuestionIndex}=this.state
		this.setState({isSurvey:false})
		activeQuestion=setToTrueFalse(activeQuestion)
		set.questions[activeQuestionIndex]=activeQuestion
		this.setState({set:set,activeQuestion:activeQuestion})
		this.saveChanges()
	}

	handleAddChoice(){
		this.lockItem()
		let {set,activeQuestion,activeQuestionIndex}=this.state
		if(activeQuestion.choices.length<4){
			const updatedSet= update(set, 
				{questions:
					{[activeQuestionIndex]:
						{choices: 
						{$push: [{correct:false, body:''}]
						}}}})	

			this.setState({set:updatedSet,activeQuestion:updatedSet.questions[activeQuestionIndex]})
			this.saveChanges()
		}
	}






	handleChangeTemplate(newTemplate){
		this.lockItem()
		const nowDate=new Date()
		const updatedSet= update(this.state.set, 
			{questions:
				{[this.state.activeQuestionIndex]:{template: {$set: newTemplate}}}
				,clientModified: {$set: nowDate}
			})
 		this.setState({set:updatedSet,activeQuestion:updatedSet.questions[this.state.activeQuestionIndex],activeQuestionTemplate:newTemplate})
		this.saveChanges()
	}



	cutQuestion(){
		this.lockItem()
		copyQuestion(this.state.activeQuestion)
 		this.deleteQuestionInSet(this.state.activeQuestionIndex)
	}

	pasteQuestion(){
		this.lockItem()
		const copiedQuestion = JSON.parse(localStorage.getItem('copiedQuestion'))

		if(copiedQuestion){
			this.newQuestionInSet(copiedQuestion)
		}
	
	}

	//will add a new question using question param if supplied, or new question template if question is not specified
	newQuestionInSet(question) {
		this.lockItem()
		const {set}=this.state	
		const indexOfNewQuestion = this.state.activeQuestionIndex + 1
		const newQuestion=newQuestionInSet(indexOfNewQuestion, set,question)

		const newQuestionsArray=
      [...set.questions.slice(0,indexOfNewQuestion), 
     	 newQuestion,
      	...set.questions.slice(indexOfNewQuestion)
      ]

		set.questions=newQuestionsArray

		this.setState({set:set,activeQuestion:newQuestion})
		this.changeActiveQuestion(newQuestion)
		this.saveChanges()
	}

	duplicateQuestion(question){
		this.lockItem()
		const questionToDuplicate=question||this.state.activeQuestion
		this.newQuestionInSet(questionToDuplicate)
	}



	deleteQuestionInSet(index) {
		this.lockItem()
		const {set}=this.state	
		if(set.questions.length >1){
			let questionIndex=index || this.state.activeQuestionIndex
			const newQuestionsArray=
	      [...set.questions.slice(0,questionIndex), 
	      	...set.questions.slice(questionIndex+1)
	      ]

			set.questions=newQuestionsArray
			this.setState({set:set})
			const newActiveIndex=Math.min(newQuestionsArray.length-1,questionIndex)
			this.changeActiveQuestion(set.questions[newActiveIndex],newActiveIndex)
			const newActiveQuestionDiv=document.getElementById(`${set.questions[newActiveIndex].questionId}`)
			if(newActiveQuestionDiv){
				newActiveQuestionDiv.focus()
			}
			this.saveChanges()
		}
	}



	changeActiveQuestion(newActiveQuestion,newActiveIndex) {
		hideMenu()
		this.props.hideNotification()
		const {set}=this.state
		const activeIndex = newActiveIndex || findIndex(set.questions, function (question) {
			return question.questionId === newActiveQuestion.questionId
		})
		let template ='standard'
		template=newActiveQuestion.template


		let activeQuestionIsSurvey=false
		if(isSurvey(newActiveQuestion)){
			activeQuestionIsSurvey=true
		}
		let hasImage=false
		if(newActiveQuestion.image !==''){
			hasImage=true
		}

		this.setState({
			activeQuestion: newActiveQuestion,
			activeQuestionIndex: activeIndex,
			activeQuestionTemplate:template,
			isSurvey:activeQuestionIsSurvey,
			hasImage:hasImage,
			tempImage: null,
			lastSaved: null,
			isSaving: false,
			unableToSave: false,
			imageSearchTerm:null,
			imageSearchResults:null,
			uploadingToCloudinary:false
		})

		
	}



	updateSetTitle(title){
		this.lockItem()
		const nowDate=new Date()
		const updatedSet= update(this.state.set, 
			{name: {$set: title},
				clientModified: {$set: nowDate}
			})
		this.setState({set:updatedSet})
		this.saveChanges()
	}      



	handleQuestionListKeyDown(e) {
		hideMenu()
		//check if keypress was an up or down arrow
		//only change activeQuestion if the form is NOT focused and there is no modal open
		//down arrow 
		if(!(e.metaKey|| e.ctrlKey) && e.keyCode === 40) {

			const activeElementId=document.activeElement.id
			const isFormFocused=(activeElementId === 'questionBodyTextArea' || activeElementId==='choiceBodyField[0]' || activeElementId==='choiceBodyField[1]'|| activeElementId==='choiceBodyField[2]'|| activeElementId==='choiceBodyField[3]' )

		


			if(!isFormFocused && !this.props.currentModal){
			// prevent scrolling container
				e.preventDefault()
				//check you are not at the bottom of the question list and change active question
				if(this.state.activeQuestionIndex !== this.state.set.questions.length - 1) {
				//if also holding shift key jump to bottom, else move 1 card down
					let newActiveQuestion
					if(e.shiftKey){
						newActiveQuestion=this.state.set.questions[this.state.set.questions.length - 1]
					}else{
					 newActiveQuestion = this.state.set.questions[this.state.activeQuestionIndex + 1]
					}
		    	this.changeActiveQuestion(newActiveQuestion)
				}
			}
		}
		//up arrow
		if(!(e.metaKey|| e.ctrlKey) && e.keyCode === 38) {
			const activeElementId=document.activeElement.id
			const isFormFocused=(activeElementId === 'questionBodyTextArea' || activeElementId==='choiceBodyField[0]' || activeElementId==='choiceBodyField[1]'|| activeElementId==='choiceBodyField[2]'|| activeElementId==='choiceBodyField[3]' )

		
			if(!isFormFocused && !this.props.currentModal){
				e.preventDefault()
				//check you are not at the top of the question list and change active question
				if(this.state.activeQuestionIndex !== 0) {
					let newActiveQuestion
					if(e.shiftKey){
						newActiveQuestion = this.state.set.questions[0]
					}else{
						newActiveQuestion = this.state.set.questions[this.state.activeQuestionIndex - 1]
		    	}
		    	this.changeActiveQuestion(newActiveQuestion)
				}
			}
		}
	}


	handleQuestionCardKeyDown(e) {
		hideMenu()
		let isViewOnly = false
  		if(this.props.parentRepo && (this.props.parentRepo.role === 'viewer' || this.props.parentRepo.role === 'consumer')){
  			isViewOnly = true
  		}
  		const {itemIsLockedByAnotherUser}=this.props
		if(!itemIsLockedByAnotherUser & !isViewOnly){
			const {set,activeQuestion,activeQuestionIndex}=this.state
			let maxNumOfQuestionsReached=false
			if(this.props.questionsInSetLimit && set && set.questions.length >= this.props.questionsInSetLimit ){
				maxNumOfQuestionsReached=true
			}	

			if((e.metaKey|| e.ctrlKey) && e.keyCode === 67) {
				copyQuestion(activeQuestion)
				const notificationMessage='to Clipboard'
				this.props.showNotification(notificationMessage,'Copied','default')
				//alert('question copied')
			}
			if((e.metaKey|| e.ctrlKey) && e.keyCode === 86 && !maxNumOfQuestionsReached) {
				this.pasteQuestion()
			}

			if((e.metaKey|| e.ctrlKey) && e.keyCode === 88) {
				this.cutQuestion()
			}
			if((e.metaKey|| e.ctrlKey) && e.keyCode === 68 ) {
				//prevent chrome bookmark page shortcut
				e.preventDefault()
				if(!maxNumOfQuestionsReached){
	 				this.duplicateQuestion()
	 			}
	 		}

			if((e.metaKey|| e.ctrlKey) && !e.shiftKey && e.keyCode === 40) {
				//check you are not at the bottom of the question list
				if(activeQuestionIndex !== set.questions.length - 1) {
				//move slide down
					e.preventDefault()
					this.moveSlideDown()
				}
			}

			if((e.metaKey|| e.ctrlKey) && !e.shiftKey && e.keyCode === 38) {
				//move slide up
				e.preventDefault()
				this.moveSlideUp()
			}

			if((e.metaKey|| e.ctrlKey) && e.shiftKey && e.keyCode === 40) {
				//move slide down
				e.preventDefault()
				this.moveSlideToBottom()
			}

			if((e.metaKey|| e.ctrlKey) && e.shiftKey && e.keyCode === 38) {
				//check you are not at the top of the question list
				if(activeQuestionIndex !== 0) {
					//move slide up
					e.preventDefault()
					this.moveSlideToTop()
				}
			}

			//delete key
			if(e.keyCode === 46 || e.keyCode === 8) {
				// delete question
				e.preventDefault()
				this.deleteQuestionInSet(activeQuestionIndex)
			}
			//enter key
			if(e.keyCode === 13 && !maxNumOfQuestionsReached) {
				this.newQuestionInSet()
			}

			if(e.keyCode === 9) { //tab
				e.preventDefault()
				//focus question body on tab 
				const questionBodyTextArea=document.getElementById('questionBodyTextArea')
				questionBodyTextArea.focus()
			}
		}

	}



	moveSlideDown(){
		this.lockItem()
		const {set,activeQuestion,activeQuestionIndex}=this.state
		if(activeQuestionIndex !== set.questions.length - 1) { 			//check you are not at the bottom of the question list
			const newQuestionsArray=[...set.questions.slice(0,activeQuestionIndex),
				...set.questions.slice(activeQuestionIndex+1,activeQuestionIndex+2),
				activeQuestion,
				...set.questions.slice(activeQuestionIndex+2),
			]

			set.questions=newQuestionsArray
			this.setState({set:set,activeQuestionIndex:activeQuestionIndex+1})
			this.saveChanges() 
		}
	}


	moveSlideToBottom(){
		this.lockItem()
		const {set,activeQuestion,activeQuestionIndex}=this.state
		const newQuestionsArray=[...set.questions.slice(0,activeQuestionIndex),
			...set.questions.slice(activeQuestionIndex+1),
			activeQuestion,
		]
		set.questions=newQuestionsArray

		this.setState({set:set,activeQuestionIndex:set.questions.length-1})
		this.saveChanges()
	  
	}

	moveSlideUp(){
		this.lockItem()
		const {set,activeQuestion,activeQuestionIndex}=this.state
		if(activeQuestionIndex !== 0){
			const newQuestionsArray=[...set.questions.slice(0,activeQuestionIndex-1),
				activeQuestion,
				...set.questions.slice(activeQuestionIndex-1,activeQuestionIndex),
				...set.questions.slice(activeQuestionIndex+1),
			]
			set.questions=newQuestionsArray
			this.setState({set:set,activeQuestionIndex:activeQuestionIndex-1})
			this.saveChanges() 
		}
	}

	moveSlideToTop(){
		this.lockItem()
		const {set,activeQuestion,activeQuestionIndex}=this.state
		const newQuestionsArray=[
			activeQuestion,
			...set.questions.slice(0,activeQuestionIndex),
			...set.questions.slice(activeQuestionIndex+1),
		]
		set.questions=newQuestionsArray
		this.setState({set:set,activeQuestionIndex:0})
		this.saveChanges() 	 

	}


	reorderQuestionsInSet(questions){
		this.lockItem()
		const {set,activeQuestion}=this.state
		set.questions=questions
		const activeIndex = findIndex(questions, function (question) {
			return question.questionId === activeQuestion.questionId
		})
		this.setState({set:set,activeQuestionIndex:activeIndex})
		this.saveChanges()
	}


	//dropdown stuff
	focusEditTitleField(){
	  document.getElementById('updateSetTitleField').focus()
	}

	delayedMenuClose(){
		hideMenu()
	}

	handleContextMenuClick(e, data){
		//context menu sets active question so no need to pass question to duplicate etc
		//we may want to add a new state contextmenu open, slide not active
		if (data.action === 'NewQuestion') {
	  	this.newQuestionInSet()
	  }
	  if (data.action === 'Duplicate') {
	  	this.duplicateQuestion()
	  }
	  if (data.action === 'Cut') {
	  	this.cutQuestion()
	  }
	 	if (data.action === 'Copy') {
	  		copyQuestion(data.question)
			const notificationMessage='to Clipboard'
			this.props.showNotification(notificationMessage,'Copied', 'default')
	  }
	  if (data.action === 'Paste') {
	  	this.pasteQuestion()
	  }
	  if (data.action === 'Delete') {
	  	this.deleteQuestionInSet(this.state.activeQuestionIndex)
	  }
	  if (data.action === 'MoveUp') {
	  	this.moveSlideUp()
	  }
	  if (data.action === 'MoveDown') {
	  	this.moveSlideDown()
	  }
		this.delayedMenuClose()
	}

	handleCopyQuestion(question){
		const questionToCopy=question || this.state.activeQuestion
		copyQuestion(questionToCopy)
		const notificationMessage='to Clipboard'
		this.props.showNotification(notificationMessage,'Copied','default')
	}


	handlePlaySet(sectionId){
		this.props.playItem(this.state.set,sectionId).then(() => {
			this.props.history.push('/liveview')		
		})		
	}     

	showImageSearchModal(){
		this.props.showImageSearchModal()
		this.lockItem()
	}


	render() {
  		let documentTitle = 'Set Editor'
  		const {set,activeQuestion,activeQuestionIndex,activeQuestionTemplate,isSurvey,lastSaved,isSaving,unableToSave,uploadingToCloudinary}=this.state
  		let isViewOnly = false
  		if(this.props.parentRepo && (this.props.parentRepo.role === 'viewer'|| this.props.parentRepo.role === 'consumer')){
  			isViewOnly = true
  		}
		if(set){				
			documentTitle=set.name
		}
		let maxNumOfQuestionsReached=false
		if(this.props.questionsInSetLimit && set && set.questions.length >= this.props.questionsInSetLimit ){
			maxNumOfQuestionsReached=true
		}	

		return (
			<DocumentTitle title={documentTitle}>
				<div className='itemEditorContainer'>
					{activeQuestion &&
						<SetEditor 
							newQuestionInSet={this.newQuestionInSet}
							handleContextMenuClick={this.handleContextMenuClick}
							set={set}
							lock={this.props.lock}
							lockItem={this.lockItem}
							currentSet={this.props.currentSet} //"real" saved set
							activeQuestion={activeQuestion}
							activeQuestionTemplate={activeQuestionTemplate}
							activeQuestionIndex={activeQuestionIndex}
							isSurvey={isSurvey}
							hasImage={this.state.hasImage}
							lastSaved={lastSaved}
							isSaving={isSaving}
							unableToSave={unableToSave}
							makeACopy={this.handleMakeACopy}
							archiveSet={this.showArchiveSetModal}
							editFormOnChange={this.handleEditFormOnChange}
							changeTemplate={this.handleChangeTemplate}
							showImageSearchModal={this.showImageSearchModal}
							showGifSearchModal={this.props.showGifSearchModal}
							uploadingToCloudinary={uploadingToCloudinary}
							tempImage={this.state.tempImage}
							setToSurvey={this.handleSetToSurvey}
							setToGraded={this.handleSetToGraded}
							setToTrueFalse={this.handleSetToTrueFalse}
							changeActiveQuestion={this.changeActiveQuestion}
							updateSetTitle={this.updateSetTitle}
							handleQuestionListKeyDown={this.handleQuestionListKeyDown}
							handleQuestionCardKeyDown={this.handleQuestionCardKeyDown}
							focusEditTitle={this.focusEditTitleField}
							reorderQuestions={this.reorderQuestionsInSet}
							updateFontSizes={this.updateFontSizes}
							handleBodyOnChange={this.handleBodyOnChange}
							handleChoiceOnChange={this.handleChoiceOnChange}
							addChoice={this.handleAddChoice}
							sections={this.props.sections}
							playItemForSection={this.handlePlaySet}
							clearTempImage={this.clearTempImage}
							duplicateQuestion={this.duplicateQuestion}
							deleteQuestionInSet={this.deleteQuestionInSet}
							copyQuestion={this.handleCopyQuestion}
							shuffleChoices={this.handleShuffleChoices}
							isShuffling={this.state.isShuffling}
							isShufflingStart={this.state.isShufflingStart}
							maxNumOfQuestionsReached={maxNumOfQuestionsReached}
							disableTemplates={this.props.disableTemplates}
							disableImageSearch={this.props.disableImageSearch}
							saveImageSearchModalImage={this.props.saveImageSearchModalImage}
							questionsInSetLimit={this.props.questionsInSetLimit}
							handleFileUpload={this.handleFileUpload}
							isViewOnly={isViewOnly}
							permissions={this.props.permissions}
							parentRepo={this.props.parentRepo}
							itemIsLockedByAnotherUser={this.props.itemIsLockedByAnotherUser}
							showRepoSelectionModal={this.props.showRepoSelectionModal}
							showDuplicateAndEditModal={()=>{this.props.showDuplicateAndEditModal(this.props.currentSet)}}
							showImportQuestionsModal={()=>{this.props.showImportQuestionsModal(this.props.currentSet?this.props.currentSet.id:'newSet')}}

						/> 
					
					}
					{/* MAY ADD BACK IN LATER
					{!activeQuestion &&
						<SetEditorLoadingPage test/>
					}
					*/}
 
					


				</div>
   		</DocumentTitle>
		)
	}
}


 
function mapStateToProps(state,ownProps) {
	const currentSet = find(state.sets, {'id':ownProps.match.params.id})
	let parentRepo
	let permissions
	let lock = null
	let itemIsLockedByAnotherUser = false
	let repoId
	let currentUserPermission
	if(currentSet && currentSet.repo){
		repoId = currentSet.repo
	}else{
		if(typeof window.repo === 'string'){//Prevent invalid folder value
			repoId=window.repo
		}
	}

	if(repoId && currentSet){
		parentRepo = find(state.repos, {'id':repoId})
		const repoLocks = state.locks[repoId]

		lock = find(repoLocks, function(lock) {
    		return lock.item === currentSet.id
		})

		if(lock && state.user){
			if(lock.user !== state.user.id){
				itemIsLockedByAnotherUser = true
			}
		}

		permissions=state.permissions[repoId]
		const currentUser=state.user


		if(permissions && currentUser.id){
			const indexOfCurrentUserPermission = permissions.findIndex(permission => {
				if(permission.user){
					return permission.user.id === currentUser.id
				}else return  permission.originalEmail === currentUser.email
			})

			currentUserPermission=permissions[indexOfCurrentUserPermission]
		}
	}



	return {
		currentUser:state.user,
		currentSet:currentSet,
		currentUserPermission:currentUserPermission,
		itemIsLockedByAnotherUser:itemIsLockedByAnotherUser,
		lock:lock,
		parentRepo:parentRepo,
		permissions:permissions,
		sections:state.sections,
		questionEditForm:state.form.editQuestionForm,
		uploadingImage:state.modals.image,
		imageSearchTerm:state.modals.imageSearchTerm,
		imageSearchResults:state.modals.imageSearchResults,
		thumbnail:state.modals.thumbnail,
		currentModal:state.modals.currentModal,
		questionsInSetLimit:state.planRestrictions.questionsInSetLimit,
		disableTemplates:state.planRestrictions.disableTemplates,
		disableImageSearch:state.planRestrictions.disableImageSearch,


	  }
}





export default withRouter(connect(
	mapStateToProps,
	{ 	
		playItem,
		showDuplicateAndEditModal,
		saveImageSearchModalImage,
		fetchASet,
		makeACopySet,
		updateSetContent,
		deleteSet,
		showConfirmModal,
		newSet, 
		showImageSearchModal,
		showGifSearchModal,
		uploadNewImageToCloudinary,
		hideModal,
		showNotification,
		hideNotification,
		finishImageUpload,
		updateSetLock,
		deleteLockForSet,
		synchronousDeleteLockForSet,
		updateSetMeta,
		loadInitialData,
		showRepoSelectionModal,
		showImportQuestionsModal
	}
)(SetEditorContainer))

